<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <div class="col-sm-12">
      <div class="d-flex  m-auto col-sm-6 col-md-6 col-xl-8 mb-3">
        <div class="col-6 q-cards text-right">
          <label class="card card-small card-list pt-2 text-center d-inline-block cursorpntr" id ="yes" (click)="getAcceptance('Yes')">Yes</label>
        </div>
        <div class="col-6 q-cards text-left pl-0">
          <label class="card card-small card-list pt-2 text-center d-inline-block cursorpntr" id ="no" (click)="getAcceptance('No')">No</label>
        </div>
      </div>
    </div>
    <div class="col-sm-12 my-4">
      <div class="col-sm-8 col-md-8 col-xl-6 card m-auto">
          <p class="semi-bold mb-0">Select an address below to modify any of your previous responses</p>
          <hr class="mt-0 mb-0">
        <div *ngFor="let address of addresses; let i = index;" class="d-flex m-auto col-sm-12 col-md-12 col-xl-12 p-1">
          <div class="col-6 pl-0">
            <agm-map [latitude]="setPos(address.geoMapAddress.geometry.location.lat)" [longitude]="setPos(address.geoMapAddress.geometry.location.lng)" [zoomControl]=false [disableDoubleClickZoom]=true [zoom]=12
              [scrollwheel]=false [streetViewControl]=false>
              <agm-marker [latitude]="setPos(address.geoMapAddress.geometry.location.lat)" [longitude]="setPos(address.geoMapAddress.geometry.location.lng)" [iconUrl]="markerIconUrl()"></agm-marker>
            </agm-map>
          </div>
          <div class="col-6 address-block px-0">
            <div class="col-12 d-flex p-0 mb-2 text-left calibre-medium">
            <div class="col-7 p-0"><p class="clrpurple">Service Address ({{i+1}})</p></div>
            <div class="col-5 p-0"><p class="pull-right calibre-normal"><a (click)="modify(i);" class="linkclr cursorpntr">Modify</a></p></div>
          </div>
            <div class="pull-left text-left">
              <p>{{address.formatedAddress}}</p>
              <p>TDSP: {{address.utility}}</p>
              <p *ngFor="let esiid of address.esiids; let j = index;">ESI ID: {{esiid.value}}</p>
              <p>Requested switch date: {{switchDates[i] | date: 'mediumDate'}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'combtn': user_bot}"
      (click)="next();">Next</button>
  </div>
  <div class="container mobileview px-0 mt-2" [attr.id]="questionObj._id" style="float:left;">
    <div class="d-flex h-100 row col-sm-12 pr-0 mt-2">
      <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/logo-charcoal.png" />
      </div>
      <div class="col-sm-9 col-9 px-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left">{{question}}</h1>
        </div>
      </div>
    </div>
    <div class="col-10 pull-right">
      <div class="col-12 d-flex mt-2 mb-2">
        <div class="col-6 pl-0 box-shadow-none">
          <label class="card card-list card-small text-center d-inline-block w-100" id ="yes_mob_q15" (click)="getAcceptance('Yes')">Yes</label>
        </div>
        <div class="col-6 pr-0 box-shadow-none">
            <label class="card card-list card-small text-center d-inline-block w-100" id ="no_mob_q15" (click)="getAcceptance('No')">No</label>
        </div>
      </div>
      <div style="width:100% !important; text-align: right;">
        <div *ngIf="user_bot" class="mb-3 ash_box mt-2">
          <h1 class="ansMob">{{yes_no}}</h1>
        </div>
      </div>
    </div>
    <div class="col-sm-12" style="float: left;">
      <div class="col-sm-8 col-md-8 col-xl-6 card m-auto mt-3">
          <p class="p-1 semi-bold mb-0 linehight">Select an address below to modify any of your previous responses</p>
          <hr class="mt-0 mb-0">
        <div *ngFor="let address of addresses; let i = index;" class="d-flex m-auto col-sm-12 col-md-12 col-xl-12 p-1">
          <div class="col-6 px-0">
            <agm-map [latitude]="setPos(address.geoMapAddress.geometry.location.lat)" [longitude]="setPos(address.geoMapAddress.geometry.location.lng)" [zoomControl]=false [disableDoubleClickZoom]=true [zoom]=12
            [scrollwheel]=false [streetViewControl]=false>
            <agm-marker [latitude]="setPos(address.geoMapAddress.geometry.location.lat)" [longitude]="setPos(address.geoMapAddress.geometry.location.lng)" [iconUrl]="markerIconUrl()"></agm-marker>
          </agm-map>
          </div>
          <div class="col-6 address-block pr-0">
            <div class="col-12 d-flex p-0 mb-2 text-left calibre-medium">
            <div class="col-7 p-0"><p class="clrpurple">Service Address ({{i+1}})</p></div>
            <!-- <div class="col-5 px-0"><p class="pull-right calibre-normal"><a (click)="modify(i);" class="linkclr cursorpntr">Modify</a></p></div> -->
          </div>
            <div class="pull-left text-left">
              <p>{{address.formatedAddress}}</p>
              <p>TDSP: {{address.utility}}</p>
              <p *ngFor="let esiid of address.esiids; let j = index;">ESI ID: {{esiid.value}}</p>
              <p>Requested switch date: {{switchDates[i] | date: 'mediumDate'}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
